export const concatEllipsis = (text: string, charactersCount: number): string => {
  return text.length > charactersCount ? `${text.substring(0, charactersCount)}...` : text;
};
